import React from "react";
import "./productReview.css";

const ProductReview = ({ productId }) => {
  const productArray =
    typeof productId === "string"
      ? productId.split("")
      : Array.isArray(productId)
        ? productId
        : [productId];

  const numbers = productArray
    .map((item) => Number(item))
    .filter((item) => !Number.isNaN(item));

  const sorted = [...numbers].sort((a, b) => b - a);

  const reviewScore = 4 + Number(sorted[0] || 5) / 10;

  const reviewCount = 18 + Number(numbers[Math.floor(numbers.length / 2)] || 6);

  const review = `${reviewScore.toFixed(1)}/5 • ${reviewCount} reviews • Selling fast`;

  return (
    <div className="sp-review-row">
      <span className="sp-stars">★★★★★</span>
      <span className="sp-review-mini">{review}</span>
    </div>
  );
};

export default ProductReview;
